module.exports = __webpack_public_path__ + "static/media/United_transparant_blue.05474d6f.png";